import { render, staticRenderFns } from "./AttendanceChannel.vue?vue&type=template&id=6eaeaaca&scoped=true"
import script from "./AttendanceChannel.vue?vue&type=script&lang=js"
export * from "./AttendanceChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaeaaca",
  null
  
)

export default component.exports